import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Elements } from '@stripe/react-stripe-js';

import App from './App';
import { stripePromise } from './stripeConfig';
import './styles.css';
import './components/CodebaseStep.css';
import './components/InfoModals.css';
import './components/SubscriptionCheckoutModal.css';
import './components/DevPasswordGate.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </StrictMode>
  );
}
